
import Card from 'vux/src/components/card/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Divider from 'vux/src/components/divider/index.vue'

import {Api} from "../../utils/api"
import {Fetch} from "../../utils/storage"
import NotFound from '../../components/NotFound'

export default {
name: 'InvoiceInfo-List',
components: {
Card,
XButton,
Divider,
NotFound
},

created () {
this.fetchInvoiceInfoList()
},

methods: {
async fetchInvoiceInfoList() {
try {
let res = await Api('GetInvoiceInfoList',{
Data:{
UserID:Fetch('ID'),
},
Limit:999,
})
this.InvoiceInfoList = res.data.List || []
}catch(err) {
this.$vux.toast.show({
text: '获取发票信息列表失败',
type: 'cancel'
})
}
},
handleInvoiceInfoAdd() {
this.$router.replace('/user/invoice-info/new')
},
handleInvoiceInfoDelete(id) {
let _this = this
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">确认删除该发票信息？删除后不可恢复！</span>',
async onConfirm() {
try {
await Api('DeleteInvoiceInfo', {}, {}, [{Name: 'ID', Value: id}])
_this.$vux.toast.show({
text: '发票信息已删除！',
type: 'text',
width: '3rem'
})
_this.Page = 1
_this.fetchInvoiceInfoList()
} catch (err) {
_this.$vux.toast.show({
text: '发票信息删除出错！',
type: 'text',
width: '3rem'
})

}
}
})
},
handleInvoiceInfoUpdate(id) {
this.$router.push(`/user/invoice-info/edit/${id}`)
},
handleInvoiceInfoSetDefault(id) {
let _this = this
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">确认将发票信息设为默认？</span>',
async onConfirm() {
try {
await Api('UpdateInvoiceInfo', {
ID: id,
Default: true
})
_this.$vux.toast.show({
text: '设置默认发票信息成功！',
type: 'text',
width: '3rem'
})
_this.Page = 1
_this.fetchInvoiceInfoList()
} catch (err) {
_this.$vux.toast.show({
text: '设置默认发票信息出错！',
type: 'text',
width: '3rem'
})

}
}
})
}
},

data () {
return {
InvoiceInfoList: []
}
}
}
